import { createSlice } from "@reduxjs/toolkit";

const plinkoActiveSlice = createSlice({
  name: "plinkoActive",
  initialState: false,
  reducers: {
    setPlinkoActive(state, action) {
      //console.log("Plinko Active State changed to:", action.payload);
      state = action.payload;
      return state;
    }
  }
});

export const { setPlinkoActive } = plinkoActiveSlice.actions;
export default plinkoActiveSlice.reducer;
